<template>
  <div class="Budget-Content">
    <div class="Left">
      <span v-if="budget.totalPrice > 0">{{ budget.totalPrice }} {{ budget.currency }}</span>
      <span v-else>免费</span>
      <img :src="budget.imageUrl" alt="">
    </div>
    <div class="Right">
      <div class="R-One R">
        <span>{{ budget.resourceNameCn }}</span>
        <van-rate v-if="budget.star > 0" v-model="budget.star" :count="budget.star" />
      </div>
      <div class="R-Two R">
        <span>{{ budget.timeStr }}</span>
      </div>
      <div class="R-Three R">
        <i v-if="budget.addressCn" class="el-icon-location-outline van-icon" />
        <span class="ellipsis">{{ budget.addressCn }}</span>
      </div>
      <div class="R-Four R">
        <span class="ellipsis">{{ budget.introduction }}</span>
      </div>
      <span class="R-Five R">
        <span v-for="(info,infoIndex) in budget.stockDetail" :key="infoIndex">
          <span>{{ info.budgetType }}  </span>
          <span>{{ info.timeDesc }}  </span>
          <span style="color: #000000;font-weight: 700;">{{ info.productNameCn }}     </span>
          <span>{{ info.stockDesc }}</span>
          <span style="color: #000000;font-weight: 700;">{{ info.ratio }}{{ info.currency }}{{ info.priceCompany }}/{{ info.useTime }}</span>
          <span style="color: rgb(142, 43, 11);font-weight: 700;"> {{ info.stockNumber }} </span>
          <span style="color: #000000;font-weight: 700;">{{ info.priceCompany }}</span>
          <span v-if="infoIndex + 1 <  budget.stockDetail.length" style="color: rgb(2, 160, 198);font-weight: bold;">  |  </span>
        </span>
      </span>
    </div>
  </div> 
</template>

<script>
// 这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）

export default {
  name:  '',
  components: {
    
  },
  props:['budget'],
  // 定义属性
  data() {
    return {
      star: 3
    }
  },
  // 计算属性，会监听依赖属性值随之变化
  computed: {},
  // 监控data中的数据变化
  watch: {},
  // 方法集合
  methods: {
    
  },
  // 生命周期 - 创建完成（可以访问当前this实例）
  created() {
    
  },
  // 生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {
    
  },
  beforeCreate() {}, // 生命周期 - 创建之前
  beforeMount() {}, // 生命周期 - 挂载之前
  beforeUpdate() {}, // 生命周期 - 更新之前
  updated() {}, // 生命周期 - 更新之后
  beforeDestroy() {}, // 生命周期 - 销毁之前
  destroyed() {}, // 生命周期 - 销毁完成
  activated() {}, // 如果页面有keep-alive缓存功能，这个函数会触发
}
</script>

<style scoped lang="scss">
  .Budget-Content {
    display: flex;
    min-height: 1.3rem;
    .Left {
      width: 1.3rem;
      height: 1.3rem;
      border-top-left-radius: 0.2rem;
      >span {
        height: 0.3rem;
        background: white;
        width: auto;
        // height: 0.5rem;
        display: flex;
        justify-content: center;
        align-items: center;
        background-color: #db4e1a;
        color: white;
        font-size: 0.18rem;
        border-top-left-radius: 0.2rem;
      }
      >img {
        width: 1.3rem;
        height: 1rem;
        background: #e4e4e4;
      }
    }
    .ellipsis {
      overflow:hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
      -o-text-overflow:ellipsis;
      display: block;
      // width: 50vw;
    }
    .Right {
      display: flex;
      flex-direction: column;
      padding: 0.05rem;
      padding-right: 0.2rem;
      .R {
        margin-left: 0.1rem;
        padding-top: 0.05rem;
        width: 3rem !important;
      }
      .R-Two {
        font-size: 0.16rem;
        color: black;
        font-weight: 700;
      }
      .R-Five {
        text-align: justify;
        text-justify:distribute-all-lines; // 这行必加，兼容ie浏览器
        text-align-last: left;
        // font-size: 0.16rem;
      }
      .R-Four {
        >span {
          color: #686868;
          // font-size: 0.16rem;
        }
      }
      .R-Three {
        display: flex;
        /deep/ .van-icon {
          display: flex;
          align-items: center;
          // font-size: 0.16rem;
        }
        >span {
          color: #686868;
          // font-size: 0.16rem;
        }
      }
      .R-One {
        width: auto;
        /deep/ .van-rate__icon--full {
          color: #db4e1a;
        }
        /deep/ .van-rate__icon {
          font-size: 0.2rem;
        }
        /deep/ .van-rate{
          margin-left: 0.1rem;
        }

        >span {
          font-weight: bold;
          color: #db4e1a;
          margin-top: 0.05rem;
          font-size: 0.18rem;
        }
      }
    }
  }
</style>